import { ChartTheme } from '../models/char-theme.enum';

export namespace ChartThemeActions {
  export class SetTheme {
    public static readonly type = '[CharTheme] Set Theme';
    public constructor(public readonly theme: ChartTheme) {}
  }
}
